import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';
import { Transition }               from '@uirouter/core';

import { CodeTypeModel }             from '../core/models/code-type';
import { MobileUserComponent }       from './user.mobile.component';
import { SessionModel }              from '../sessions/models/session';
import { SessionService }            from '../sessions/session.service';
import { UserComponent }             from './user.component';
import { UserModel }                 from './typings/user';
import { UserNotificationTypeModel } from './typings/user.notification-type';
import { UsersComponent }            from './users.component';
import { UserSettingsComponent }     from './user.settings.component';
import { UserSettingsModel }         from './typings/user.settings';
import { UsersMechanicModel }        from './typings/users.mechanic';
import { UsersService }              from './users.service';


export const UsersStates : Array<NgHybridStateDeclaration> = [
  {
    component: MobileUserComponent,
    name     : 'app.mobile-user',
    params   : {
      id: {
        squash: true,
        value : null
      },
      mechanic_id: {
        squash: true,
        value : null
      }
    },
    resolve: [
      {
        deps     : [ UsersService, Transition ],
        resolveFn: ( UsersService : UsersService, transition : Transition ) : Promise<UsersMechanicModel> => {
          const id = transition.params().mechanic_id;

          return id
            ? UsersService.getMechanic(id)
            : Promise.resolve({} as UsersMechanicModel);
        },
        token: 'mechanic'
      },
      {
        deps     : [ UsersService, Transition ],
        resolveFn: ( usersService : UsersService, transition : Transition ) : Promise<Array<UserNotificationTypeModel>> => {
          const id = transition.params().id;

          return id
            ? usersService.getMobileNotificationTypes(id)
            : Promise.resolve([]);
        },
        token: 'notificationTypes'
      },
      {
        deps     : [ UsersService ],
        resolveFn: ( UsersService : UsersService ) : Promise<Array<CodeTypeModel>> => UsersService.getStateTypes(),
        token    : 'statusTypes'
      },
      {
        deps     : [ UsersService, Transition ],
        resolveFn: ( UsersService : UsersService, transition : Transition ) : Promise<UserModel> => {
          const id = transition.params().id;

          return id
            ? UsersService.getUser(id)
            : Promise.resolve({} as UserModel);
        },
        token: 'user'
      }
    ],
    url: '/:mechanic_id/mobile_user/:id'
  },
  {
    component: UserComponent,
    name     : 'app.user',
    params   : {
      id: {
        squash: true,
        value : null
      }
    },
    resolve: [
      {
        deps     : [ UsersService, Transition ],
        resolveFn: ( usersService : UsersService, transition : Transition ) : Promise<Array<UserNotificationTypeModel>> => {
          const id = transition.params().id;

          return id
            ? usersService.getMobileNotificationTypes(id)
            : Promise.resolve([]);
        },
        token: 'notificationTypes'
      },
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : Promise<SessionModel> => sessionService.refresh(),
        token    : 'session'
      },
      {
        deps     : [ UsersService, Transition ],
        resolveFn: ( UsersService : UsersService, transition : Transition ) : Promise<UserModel> => {
          const id = transition.params().id;

          return id
            ? UsersService.getUser(id)
            : Promise.resolve({} as UserModel);
        },
        token: 'user'
      },
      {
        deps     : [ UsersService ],
        resolveFn: ( UsersService : UsersService ) : Promise<any> => UsersService.getQuote(),
        token    : 'userQuote'
      }
    ],
    url: '/user/:id'
  },
  {
    component: UserSettingsComponent,
    name     : 'app.user-settings',
    resolve  : [
      {
        deps     : [ UsersService ],
        resolveFn: ( usersService : UsersService ) : Promise<Array<CodeTypeModel>> => usersService.getJobCardOptions(),
        token    : 'jobCardOptions'
      },
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : UserSettingsModel => sessionService.user(),
        token    : 'settings'
      },
      {
        deps     : [ UsersService ],
        resolveFn: ( usersService : UsersService ) : Promise<UserModel> => usersService.getUser(),
        token    : 'user'
      }
    ],
    url: '/user_settings?code&xero_request_successful&google_link_success&google_link_error'
  },
  {
    component: UsersComponent,
    name     : 'app.users',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : Promise<boolean> => sessionService.isAdminUser()
          ? Promise.resolve(true)
          : Promise.reject(false),
        token: 'authorized'
      }
    ],
    url: '/users'
  }
];
